<template>
  <v-flex xs12 sm12 class="pa-4">

    <vue-dropzone
        ref="myVueDropzone" id="dropzonefile"
        :options="options" @vdropzone-complete="onUploadComplete" @vdropzone-sending="onUploadStart">
    </vue-dropzone>

  </v-flex>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';

import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
export default {
  name: "UploadMediaCenter",
  components:{
    vueDropzone: vue2Dropzone,
  },
  created() {
    this.options.url= `${this.getEndpoint}api/v1/multimedia/dropzone`
    this.options.headers= {'Authorization': `Bearer ${this.getUser.token}`}
  },
  computed: {
  ...mapGetters({
      'getUser':'user/getUser',
      'getEndpoint':'settings/getEndpoint',

    }),
  },
  data() {
    return {
      options: {
        url: "",
        thumbnailWidth: 150,
        maxFilesize: 20,
        acceptedFiles: '.jpg,.png,.gif,.jpeg',
        headers: "",
        method: "POST",
        dictDefaultMessage: this.$t('uploadOrDragImages')
      },
    }
  },
  methods:{
    onUploadComplete(result) {
      if(result.status == 'success'){
        var response = JSON.parse(result.xhr.response)
        this.$emit('message',response.url)
      }

    },
    onUploadStart (file, xhr, formData) {
      formData.append('type', 'media_centers');
      formData.append('center_id',this.$route.params.id)
    },
  }
}
</script>

<style scoped>

</style>